(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('UserSettingsController', UserSettingsController);

    UserSettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate','GenericService'];

    function UserSettingsController (Principal, Auth, JhiLanguageService, $translate,GenericService) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;
        vm.units = null;
		vm.currency = null;
		vm.settings={};

        var copyAccount = function (account) {
            return {
                login: account.login
                
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
        	GenericService.saveUserSettingsData(vm.settings, function(data) {
				vm.success = 'OK';
				
        }).catch(function() {
            vm.success = null;
            vm.error = 'ERROR';
        });
        	
        }
        
        function getSettingsData(){
        	        	GenericService.getUserSettingsData().then(
			 function(data) {
				vm.unitsData = data[0];
				vm.currencyData = data[1];
				
        });
        	
        }
        
        function getuserData(){
        	        	GenericService.getuserData().then(
			 function(data) {
				vm.settings = data;
        });
        	
        }
        
        getuserData();
        getSettingsData();
    }
})();
